var ListCodeModule = (function () {
    function ListCodeModule() {
    }
    return ListCodeModule;
}());
export { ListCodeModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/list-code/list-code.module.ts.pre-build-optimizer.js